<p-confirmDialog [transitionOptions]="'0ms'" key="confirmdistricencos" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>
<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="nomdistricen"></p-toast>
<div class="p-grid" style="width: 98%">
    <div class="p-col-12">
        <app-invmaebarra [botonNuevo]="btnNuevo" [botonGuardar]="btnGuardar" [botonRegresar]="btnRegresar"
            [botonBorrar]="btnBorrar" [botonAnterior]="botonAnterior" [botonPrimero]="botonPrimero"
            [botonUltimo]="botonUltimo" [botonSiguiente]="botonSiguiente" [barraBotones3]="true"
            [botonBuscar]="btnBuscar" [botonBinocular]="true" [botonExcelPermanente]="true" [botonAlmacenardoc]="false"
            (signal)="manejarSenales($event)">
        </app-invmaebarra>
    </div>
</div>
<div class="layout-config">
    <div class="layout-config-content-wrapper">
        <a class="layout-config-button" id="layout-config-button" style="cursor: pointer" (click)="acciones()">
            <i class="pi pi-bars" style="cursor: pointer"></i>
        </a>
        <p-sidebar class="layout-config-content" position="right" [(visible)]="displayAcciones" [modal]="false"
            [dismissible]="true" [showCloseIcon]="false">
            <br>
            <br>
            <br>
            <p-tabView>
                <p-tabPanel header="Acciones">
                    <div class="p-grid">
                        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 200px)'}">
                            <div class="p-col-12">
                                <i class="pi pi-caret-right archivoOpc"></i><span (click)="elimdistricc()"
                                    class="archivoOpc">Eliminar la distribución de los roles en proceso</span>
                            </div>
                            <!-- <div class="p-col-12">
                                <i class="pi pi-caret-right archivoOpc"></i><span (click)="cargarcencostos()"
                                    class="archivoOpc">Cargar distribución por centro de costos</span>
                            </div> -->
                        </p-scrollPanel>
                    </div>
                </p-tabPanel>
            </p-tabView>
        </p-sidebar>
    </div>
</div>
<p-tabView [(activeIndex)]="index" (onChange)="changeTabs()" [style]="{'width':'98%'}">
    <p-tabPanel header="General">
        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 270px)'}">
            <div class="contorno" id="contorno">
                <div class="divgrups">
                    <div class="p-grid">
                        <div class="p-col-6">
                            <span style="font-size: medium;">{{fechasPeriodo}}</span>
                        </div>
                        <div class="p-col-2"></div>
                        <div class="p-col-4"></div>
                        <!-- <div class="p-col-4">
            <table style="width: 100%;">
                <tr style="background-color: rgba(66, 214, 240, 0.829);">
                    <td style="border: 1px solid; text-align: center;">{{identiUsuario}}</td>
                    <td style="border: 1px solid; text-align: center;">{{fecha | date: 'dd/MM/yyyy' }}</td>
                    <td style="border: 1px solid; text-align: center;">{{fecha | date: 'hh:mm' }}</td>
                </tr>
            </table>
        </div> -->
                    </div>
                    <div class="p-grid">
                        <div class="p-col-2">
                            <span style="margin-left: 5px;">Departamento:</span>
                        </div>
                        <div class="p-col-4">
                            <!-- <p-dropdown [options]="cmbTIPROL" [style]="{'minWidth': '100%', 'width':'100%'}"
                                optionLabel="DEP_NOMBRE" optionValue="TIPROL_CODIGO" [panelStyle]="{'width':'110%'}"
                                (onChange)="selecTipoRol($event)">
                            </p-dropdown> -->
                            <p-dropdown [options]="cmbTIPROL" [style]="{'width':'100%'}" optionLabel="DEP_NOMBRE"
                                [panelStyle]="{'width':'110%'}" (onChange)="selecTipoRol($event)"
                                [(ngModel)]="selecttipodep" [disabled]="false"></p-dropdown>
                        </div>
                        <div class="p-col-1"></div>
                        <div class="p-col-1">
                            <!-- <span style="margin-left: 5px;">Asiento:</span> -->
                        </div>
                        <div class="p-col-4">
                            <!-- <p-dropdown [options]="cmbASI_NRO" [style]="{'minWidth': '100%', 'width':'100%'}" optionLabel="ASI_NRO"
                optionValue="ASI_NRO" [panelStyle]="{'width':'110%'}" [(ngModel)]="selectedAsiento"
                (onChange)="selecAsiento($event)">
            </p-dropdown> -->
                        </div>
                    </div>
                </div>
            </div>
            <app-aggridsaci [width]="" [height]="80" [enableSorting]="true" [enableFilter]="true"
                [rowData]="nomdistricencostosService.detdistricen" [frameworkComponents]="frameworkComponents"
                [animateRows]="true" [rowSelection]="rowSelection" [columnDefs]="columnDefsDetdistricen"
                [defaultColDef]="defaultDetdistricen" [rowStyle]="rowStyle" [singleClickEdit]="false" [botones]="true"
                [mostrarGuardar]="false" [botonDistribCC]="false" [comboOpciones]="" [solobotoneliminar]="false"
                [solobotoneliminar]="true" [btnsubirxls]="true" (selected)="seleccionItem($event)" [tipodetalle]=""
                (cambios)="cambio($event)" [CC]="true">
            </app-aggridsaci>
        </p-scrollPanel>
    </p-tabPanel>
</p-tabView>
<p-dialog header="Busqueda de Datos" [(visible)]="displayDialogBusquedaFast" [transitionOptions]="'0ms'" [modal]="true"
    appendTo="body" [style]="{width: '70vw', height: '70vh'} ">
    <app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [consulta]="consulta" [tabla]="tabla"
        [where]="where" [busquedaParams]="busquedacampos" (opcionSeleccionada)="manejarSeleccion($event)">
    </app-busquedadlg>
</p-dialog>
<p-dialog header="Distribución de costos" [(visible)]="displayDialogDistribucion" [transitionOptions]="'0ms'"
    [modal]="true" appendTo="body" [style]="{width: '70vw', height: '70vh'} ">
    <app-nomtrndistricen *ngIf="displayDialogDistribucion" [rucide]="detnomdistricenSelected.EMP_RUCIDE"
        [detalle]="detnomdistricenSelected"
        [strnum]="nomdistricencostosService.encdistricen[indicador].ENCDISCEN_CODIGO"
        [nomemp]="detnomdistricenSelected.EMP_NOMBRE" (salir)="salirDialog()">
    </app-nomtrndistricen>
</p-dialog>

<input #inputFile type="file" style="display: none; opacity: 0.0; position: absolute; 
			top: 0; left: 0; bottom: 0; right: 0; width: 25px; height: 25px; cursor: pointer;" accept=".xls, .xlsx"
    (change)="onBasicUpload(inputFile.files)" />

<div style=" 	position: fixed;
                				z-index: 999;
                				height: 2em;
                				width: 2em;
                				overflow: visible;
                				margin: auto;
                				top: 0;
                				left: 0;
                				bottom: 0;
                				right: 0;
                
                				">
    <p-progressSpinner *ngIf="spin" [style]="{width: '100px', height: '100px'}" animationDuration=".5s">
    </p-progressSpinner>
    <p-dialog [(visible)]="spin" [transitionOptions]="'0ms'" [modal]="true" [closable]="false"
        [style]="{ opacity: 0.00}" position="top">
    </p-dialog>
</div>

<p-dialog header="Reportes" [(visible)]="displayDialogReportes" [transitionOptions]="'0ms'" [modal]="true"
    appendTo="body" [style]="{width: '40vw', height: '400px'}">
    <app-sacimaecfngimpr [auxiliar]="auxreporte" [strNombreForma]="strNombreForma"
        [strNumDoc]="nomdistricencostosService.encdistricen[indicador].ENCDISCEN_CODIGO" [strCampo]="'ENCDISCEN_CODIGO'"
        [botonExcel]="true" (cerrar)="cerrarReportes()"></app-sacimaecfngimpr>
</p-dialog>